const writeLocalStorage = (key, value) => {
  // Convert the value to a string
  const data = JSON.stringify(value);
  // Store the data using the key
  localStorage.setItem(key, data);
};

// A function to read data from local storage
const readLocalStorage = (key) => {
  // Get the data using the key
  const data = localStorage.getItem(key);
  // Parse the data as JSON
  const value = JSON.parse(data);
  // Return the value
  return value;
};

export {
  writeLocalStorage,
  readLocalStorage,
};


